/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Suggest_Agent_Reading_RateInputs */



/**
* | output |
* | --- |
* | "Fix all reading rate issues" |
*
* @param {Assistant_Suggest_Agent_Reading_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_suggest_agent_reading_rate = /** @type {((inputs?: Assistant_Suggest_Agent_Reading_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Suggest_Agent_Reading_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résoudre tous les problèmes de vitesse de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Lesegeschwindigkeitsprobleme beheben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risolvi tutti i problemi relativi alla velocità di lettura.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправлены все проблемы со скоростью чтения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solucionar todos los problemas de velocidad de lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修复所有阅读速度问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読書速度に関するすべての問題を修正しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पढ़ने की गति से संबंधित सभी समस्याओं को ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir todos os problemas de velocidade de leitura")
	return /** @type {LocalizedString} */ ("Fix all reading rate issues")
});